import { render, staticRenderFns } from "./GroupCustomerForm.vue?vue&type=template&id=70f1cb56&"
import script from "./GroupCustomerForm.vue?vue&type=script&lang=js&"
export * from "./GroupCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports